import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons';

import { getDates, getTimes, getActualTime, getToday} from '../utils/helpers';
import  ClientOnly  from './ClientOnly';

export default ({ onFilter, filters }) => {
  const [showOptions, setShowOptions] = useState(false);

  const onSelectDate = (e) => {
    onFilter({
      type: 'date',
      filter: e.target.value,
    });
  };

  const onSelectTime = (e) => {
    onFilter({
      type: 'time',
      filter: e.target.value,
    });
  };

  const today = () => {
    onFilter({
      type: 'time',
      filter: getActualTime(),
    });
    onFilter({
      type: 'date',
      filter: getDates()[0].value,
    });
  }

  return (
    <Container>
      <Button onClick={() => setShowOptions(!showOptions)} isActive={showOptions}>
        {showOptions ? (
          <>
            <FontAwesomeIcon icon={faTimes} size="lg" />
            <div className="text">Cerrar</div>
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={faClock} size="2x" />
            <div className="text">Horarios</div>
          </>
        )}
      </Button>
      <Options show={showOptions}>
        <ClientOnly>
          <SelectContainer>
            <Select
              onChange={onSelectDate}
              defaultValue={getToday()}
            >
              {
                getDates().map((date) => (
                  <Option value={date.value} key={date.text}>
                    {date.text}
                  </Option>
                ))
              }
            </Select>
            <IconSelect>
              <FontAwesomeIcon icon={faChevronDown} />
            </IconSelect>
          </SelectContainer>
        </ClientOnly>

        <Separation />

        <SelectContainer>
          <Select
            onChange={onSelectTime}
            value={filters.time}
          >
            {
              getTimes().map((time) => (
                <Option value={time.value} key={time.value}>
                  {time.text}
                </Option>
              ))
            }
          </Select>
          <IconSelect>
            <FontAwesomeIcon icon={faChevronDown} />
          </IconSelect>
        </SelectContainer>
        <Today onClick={today} > Hoy </Today>
      </Options>
    </Container>
  );
};

const Container = styled.div`
  ${tw`
    flex justify-start items-center
    absolute bottom-0 right-0 mb-56
  `}
`;

const Options = styled.div`
  ${tw`
    bg-white hidden shadow-md rounded-l-md
    h-20 px-4 py-1 flex-col justify-around items-center
  `}

  ${(props) => props.show && tw`
    flex 
  `}

  @media (min-width: 768px) {
    ${tw`
      hidden
    `};
  }
`;

const Button = styled.div`
  background-color: #7BBC57;

  .text {
    ${tw`mt-1`}
  }

  ${tw`
    rounded-l-md
    shadow-md text-white text-center text-xs
    px-2 h-16 flex items-center flex-col justify-center
  `}

  ${(props) => props.isActive && css`
    // background: white;
    // color: #7BBC57;
    height: 50px;
  `}

  @media (min-width: 768px) {
    ${tw`
      hidden
    `};
  }
`;

const SelectContainer = styled.div`
  ${tw`
    flex items-center justify-between w-full
  `}
`;

const Select = styled.select`
  box-sizing: border-box;
  color: #5c5c5c;

  ${tw`
    border-none py-1 outline-none text-left w-full text-base
    appearance-none cursor-pointer bg-transparent pr-2
  `}
`;

const Option = styled.option``;

const IconSelect = styled.div`
  color: #7BBC57;
`;

const Separation = styled.div`
  background-color: #DEDEDE;
  ${tw`
    h-px w-full mx-2
  `}
`;

const Today = styled.button`
  box-sizing: border-box;
  color: #5c5c5c;
  background-color: #F0F0F0;

  ${tw`
    border-none px-8 py-1 outline-none
    rounded-full mx-4 appearance-none cursor-pointer
  `}
`;
